



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import ExchangeList from './ExchangeList.vue';
@Component({
  components: { AdminIframe, ExchangeList },
})
export default class ExchangeIframe extends Vue {
  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/claim/exchanges' + '?' + queryString;
    return src;
  }
}
